// extracted by mini-css-extract-plugin
module.exports =  {"drawer-absolute-footer-buttons":"FormSkeleton-module__drawer-absolute-footer-buttons___sDa5l"};